import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { SITE_URL } from "../data/business";

export default function Breadcrumbs({ items = [] }) {
  // JSON-LD BreadcrumbList for SEO
  React.useEffect(() => {
    const list = [{ name: "Home", url: "/" }, ...items.map((it) => ({ name: it.label, url: it.to || "" }))];
    const ld = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": list.map((it, i) => ({
        "@type": "ListItem",
        "position": i + 1,
        "name": it.name,
        "item": `${SITE_URL}${it.url}`,
      })),
    };
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.setAttribute("data-lc-breadcrumb", "1");
    s.text = JSON.stringify(ld);
    document.head.appendChild(s);
    return () => { document.querySelectorAll('script[data-lc-breadcrumb]').forEach((n) => n.remove()); };
  }, [items]);

  return (
    <nav aria-label="Breadcrumb" className="text-[13px] text-dark/60 flex items-center gap-1.5 flex-wrap" data-testid="breadcrumbs">
      <Link to="/" className="hover:text-dark">Home</Link>
      {items.map((it, i) => (
        <React.Fragment key={i}>
          <ChevronRight size={12} className="opacity-50" />
          {it.to ? <Link to={it.to} className="hover:text-dark">{it.label}</Link> : <span className="text-dark font-medium">{it.label}</span>}
        </React.Fragment>
      ))}
    </nav>
  );
}
